import { createActions } from 'redux-actions';
import { normalize } from 'normalizr';
import { API } from 'aws-amplify';

import * as t from './actionTypes';
import * as schema from './schema';
import { getApp } from './selectors';
import misc from '../misc';

const actionCreators = createActions({
  [t.ENTITIES_ADD]: [entities => entities, () => ({ updatedAt: Date.now() })],
  [t.NETWORK_START]: undefined,
  [t.NETWORK_RESET]: undefined,
  [t.NETWORK_ERROR]: undefined,
  [t.ACTIVE_SET]: undefined,
  [t.SEARCH_SET]: undefined
});

/**
 * Fetch records from API
 */
export const fetchClients = () => async dispatch => {
  dispatch(actionCreators.clients.networkStart());
  let res;
  try {
    res = await API.get('ptapp', '/clients');
  } catch (e) {
    dispatch(actionCreators.clients.networkError(e.message));
    return;
  }
  const data = normalize(res, schema.clientList);
  dispatch(actionCreators.clients.entitiesAdd(data.entities.clients));
  dispatch(actionCreators.clients.networkReset());
};

/**
 * Fetch records from API if cache has expired
 */
export const fetchClientsIfNeeded = () => async (dispatch, getState) => {
  const app = getApp(getState());
  const lastUpdate = app && app.get('lastUpdate');
  const cacheTime = Date.now() - lastUpdate;
  if (lastUpdate === null || cacheTime > 60000 * 5) {
    // 5 minute cache
    fetchClients()(dispatch);
  }
};

/**
 * Update record through API
 * @param  {string} id      The id to update, or undefined
 * @param  {object} values  New values for record
 * @param  {object} history react-router-dom history
 */
export const submitClientEdit = (id, values, history) => async dispatch => {
  dispatch(actionCreators.clients.networkStart());
  const payload = {
    body: {
      firstName: values.get('firstName'),
      lastName: values.get('lastName'),
      email: values.get('email'),
      phone: values.get('phone')
    }
  };
  try {
    let res;
    if (typeof id === 'undefined') {
      res = await API.post('ptapp', '/clients', payload);
      id = res.id;
    } else {
      res = await API.put('ptapp', `/clients/${id}`, payload);
    }
    const data = normalize(res, schema.client);
    dispatch(actionCreators.clients.entitiesAdd(data.entities.clients));
  } catch (e) {
    dispatch(actionCreators.clients.networkReset());
    misc.lib.throwSubmissionErrorFromAxiosError(e);
  }

  dispatch(actionCreators.clients.activeSet(id));
  history.push('/clients/' + id);
  dispatch(actionCreators.clients.networkReset());
};

/**
 * Set active record
 * @param {string} id The ID of the record to set as active
 */
export const setActive = id => async dispatch => {
  dispatch(actionCreators.clients.activeSet(id));
};

/**
 * Set search term
 * @param {string} term The new search term
 */
export const setSearch = term => async dispatch => {
  dispatch(actionCreators.clients.searchSet(term));
};



// WEBPACK FOOTER //
// ./src/modules/clients/actions.js